import { useEffect, useMemo, useState } from "react";
import { fetchFrequentlyAsked, fetchSuggestions, fetchUnansweredQuestions, fetchRecentDocuments } from "../services/overviewListsService";

function computeDefaultRange(days = 30) {
	const end = new Date();
	const start = new Date(end.getTime() - days * 24 * 60 * 60 * 1000);
	return {
		start: start.toISOString(),
		end: end.toISOString()
	};
}

export function useFrequentlyAsked(limit = 10, days = 30) {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const range = useMemo(() => computeDefaultRange(days), [days]);
	useEffect(() => {
		let cancelled = false;
		(async () => {
			setLoading(true);
			setError(null);
			try {
				const rows = await fetchFrequentlyAsked(range.start, range.end, limit);
				if (!cancelled) setData(rows);
			} catch (e) {
				if (!cancelled) setError(e);
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [range.start, range.end, limit]);
	return { data, loading, error };
}

export function useSuggestions(limit = 10) {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	useEffect(() => {
		let cancelled = false;
		(async () => {
			setLoading(true);
			setError(null);
			try {
				const rows = await fetchSuggestions(limit);
				if (!cancelled) setData(rows);
			} catch (e) {
				if (!cancelled) setError(e);
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [limit]);
	return { data, loading, error };
}

export function useUnansweredQuestions(limit = 10, days = 30) {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const range = useMemo(() => computeDefaultRange(days), [days]);
	useEffect(() => {
		let cancelled = false;
		(async () => {
			setLoading(true);
			setError(null);
			try {
				const rows = await fetchUnansweredQuestions(range.start, range.end, limit);
				if (!cancelled) setData(rows);
			} catch (e) {
				if (!cancelled) setError(e);
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [range.start, range.end, limit]);
	return { data, loading, error };
}

export function useRecentDocuments(limit = 5, days = 30) {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const range = useMemo(() => computeDefaultRange(days), [days]);
	useEffect(() => {
		let cancelled = false;
		(async () => {
			setLoading(true);
			setError(null);
			try {
				const rows = await fetchRecentDocuments(range.start, range.end, limit);
				if (!cancelled) setData(rows);
			} catch (e) {
				if (!cancelled) setError(e);
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [range.start, range.end, limit]);
	return { data, loading, error };
}


